import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, Grid } from '@mui/material';

import Select from '../../../../../../common/components/Select/Select';
import MenuItem from '../../../../../../common/components/MenuItem/MenuItem';
import { ConfigurationFieldLabel } from '../ConfigurationFieldLabel';
import { CurrentConfigureValue } from '../CurrentConfigureValue';
import { getProcessedStatus } from '../../ChargerConfigurationHelper';

export class ChargerConfigurationSelectField extends React.Component {
  onChange = (event) => {
    const normalizedValue = this.props.multiple ? event.target.value.join(';') : event.target.value;

    this.props.input.onChange(normalizedValue);
    this.props.onFieldChange({ fieldName: this.props.input.name });
  };

  onOpenHandler = () => {
    if (!this.props.isModal) return;

    const selectedValues = this.props.input.value;
    const { value } = this.props.options[0];

    if (!selectedValues && Boolean(value)) {
      this.props.input.onChange(value);
    }
  };

  render() {
    const {
      label,
      disabled,
      multiple,
      description,
      currentValue,
      status,
      input: { value, name },
      meta: { dirty, form, touched },
      isBatchUpdate,
      isModal,
    } = this.props;

    const children = this.props.options.map((option) => (
      <MenuItem key={option.value} value={option.value} title={option.label} fullWidth>
        {option.label}
      </MenuItem>
    ));

    const normalizedValue = multiple ? (value && value.split(';')) || [] : value;

    const processedStatus = getProcessedStatus(isBatchUpdate ? dirty || touched : dirty, status);

    const wrappedLabel = <ConfigurationFieldLabel label={label} description={description} status={processedStatus} />;

    const currentValueComponent = isBatchUpdate ? (
      this.props.batchUpdateButton(dirty || touched)
    ) : (
      <CurrentConfigureValue dirty={dirty} status={processedStatus} currentValue={currentValue} />
    );

    return (
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <div className="charger-configuration-field">
            <FormControl fullWidth>
              <InputLabel shrink>{wrappedLabel}</InputLabel>
              <Select
                value={normalizedValue}
                name={name}
                multiple={multiple}
                disabled={disabled}
                inputProps={{
                  form,
                }}
                onChange={this.onChange}
                onOpen={this.onOpenHandler}
                fullWidth
              >
                {children}
              </Select>
            </FormControl>
            {this.props.clearButton({ processed: processedStatus, actual: status })}
          </div>
        </Grid>
        {!isModal && (
          <Grid item className="current-value-grid-container">
            {currentValueComponent}
          </Grid>
        )}
      </Grid>
    );
  }
}

ChargerConfigurationSelectField.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
};
